/**
 * Created by guwei on 2017/12/29.
 */
module.exports = require("./script/jsBridge.js");